import { action } from 'satcheljs';
import { Account } from '../store/schema';

export const onAccountChanged = action('onAccountChanged', (account?: Account) => ({ account }));
export const onAccountSelected = action('onAccountSelected', (id: string) => ({ id }));
